// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__LsIML","additionalInfo":"AgreementModal_additionalInfo__3eFmx"};